import { useEffect, useState } from "react";

import firebase from "firebase/compat/app";

import { SupportEmailDocument } from "./support-email.model";

export const useSupportEmail = (supportEmailId: string) => {
    const [state, setState] = useState<SupportEmailDocument | null>();

    useEffect(() => {
        setState(undefined);

        return firebase.firestore().collection("support-emails").doc(supportEmailId).onSnapshot(document => {
            if ( !document.exists ) return setState(null);

            const supportEmail = { id: document.id, ...document.data() } as SupportEmailDocument;

            setState(supportEmail);
        });
    }, [supportEmailId]);

    return state;
};
